import { render } from "./DynamicTable2_Stable.vue?vue&type=template&id=9e8da394&scoped=true"
import script from "./DynamicTable2_Stable.vue?vue&type=script&lang=js"
export * from "./DynamicTable2_Stable.vue?vue&type=script&lang=js"

import "./DynamicTable2_Stable.vue?vue&type=style&index=0&id=9e8da394&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8da394"]])

export default __exports__